webpackJsonp([1747531747429],{

/***/ 1929:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"PharmacyMedicationLock","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"lastEditedAt","type":{"kind":"SCALAR","name":"DateTime","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"lastEditedById","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"lastEditedBySessionId","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"medicationId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"providerName","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-pharmacy-medication-lock-b3c758d062df1452c7a9.js